import React from "react";

const VARIANTS = {
  active: "bg-green-100 text-green-800",
  archived: "bg-amber-700 text-white",
  inactive: "bg-gray-200 text-gray-700",
  suspended: "bg-red-100 text-red-800",
};

export default function StatusBadge({ status = "active", label }) {
  const normalized = String(status).toLowerCase();
  const display =
    label ||
    (normalized === "active"
      ? "Active"
      : normalized === "archived"
        ? "Archived"
        : normalized === "suspended"
          ? "Suspended"
          : normalized === "inactive"
            ? "Inactive"
            : status);

  const cls = VARIANTS[normalized] || VARIANTS.inactive;

  return (
    <span className={`inline-flex items-center px-2 py-1 rounded-full text-sm ${cls}`}>
      {display}
    </span>
  );
}
